var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 32.06L24.74 38l9.73-11.76M4.71 22.52h12.64v.01H4.71zm0-4.71h14.64v.01H4.71zm0-4.7h16.64v.01H4.71zm0-4.73h10.58v.03H4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61 33H1V1h23.95L25 22.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8365fb64bab6cc1ea196ef68417d2cc9.svg";
export { ForwardRef as ReactComponent };